import { render, staticRenderFns } from "./texts.vue?vue&type=template&id=00a86c44&scoped=true&"
import script from "./texts.vue?vue&type=script&lang=js&"
export * from "./texts.vue?vue&type=script&lang=js&"
import style0 from "./texts.vue?vue&type=style&index=0&id=00a86c44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a86c44",
  null
  
)

export default component.exports